import { React, useEffect, useState } from 'react';
import { Autocomplete, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  AutoCompleteRenderOptionBox,
  StyledSVGCircleIcon,
  StyledSVGIcon,
} from './utils';
import { ReactComponent as CheckedIcon } from '../../../../assets/annotation-assets/check.svg';
import { ReactComponent as CircleIcon } from '../../../../assets/common-assets/filled-circle.svg';

const DataFieldDropdown = ({
  label,
  setLabel,
  checkedDataFields,
  data,
  openedData,
  products,
  changedData,
  setIsDataFieldSelected,
  versionId,
  isEditing,
  isDate,
}) => {
  const [DataFields, setDataFields] = useState([]);
  const [labelExist, setLabelExist] = useState('');

  const getAllDataFields = () => {
    if (labelExist !== '') {
      if (openedData.product !== undefined) {
        const options = Object.values(checkedDataFields).reduce(
          (accumulator, response) => {
            const labelData = data.filter(
              (item) =>
                item.product &&
                item.label &&
                item.product === openedData.product,
            );

            const productData = labelData.map((item) => item.label);
            response.forEach((DataField) => {
              if (
                !accumulator.includes(DataField?.short_desc) &&
                !productData.includes(DataField?.annotation_field) &&
                DataField.group === 'Product'
              ) {
                accumulator.push(DataField?.short_desc);
              }
            });
            return accumulator;
          },
          [],
        );
        setDataFields(options);
      } else {
        const options = Object.values(checkedDataFields).reduce(
          (accumulator, response) => {
            const labelData = data.map((item) => item.label);
            response.forEach((DataField) => {
              if (
                !accumulator.includes(DataField?.short_desc) &&
                !labelData.includes(
                  DataField?.annotation_field || DataField?.short_desc,
                ) &&
                DataField.group !== 'Product'
              ) {
                accumulator.push(DataField?.short_desc);
              }
            });
            return accumulator;
          },
          [],
        );
        setDataFields(options);
      }
    } else {
      const productsFieldsData = products.flatMap((group) => group);
      const options = Object.values(checkedDataFields).reduce(
        (accumulator, response) => {
          response.forEach((DataField) => {
            if (!accumulator.includes(DataField?.short_desc)) {
              accumulator.push(DataField?.short_desc);
            }

            const matchingLabels = productsFieldsData.filter(
              (m) => m.label === DataField?.annotation_field,
            );
            const product = matchingLabels.map((matchingLabel) => ({
              ...matchingLabel,
              short_desc: DataField?.short_desc,
            }));

            accumulator = [...accumulator, product];
            const productArray = [];

            for (let i = 1; i <= products.length; i++) {
              productArray.push(i);
            }
            const newArray = accumulator.filter(
              (i) => typeof i !== 'string' && i.length > 0,
            );
            if (newArray.length !== response.length) {
              const ProductLabel = [
                ...new Set(productsFieldsData.map((p) => p.label)),
              ];
              const arrayLengths = newArray.filter(
                (innerArray) => innerArray.length !== products.length,
              );
              if (arrayLengths.length > 0) {
                const responseProduct = response.map((item) => item.short_desc);
                const ProductRemaining = accumulator.filter(
                  (item) =>
                    typeof item === 'string' && item.startsWith('Product'),
                );
                const remainingProduct = responseProduct.filter(
                  (item) => !ProductRemaining.includes(item),
                );
                accumulator = accumulator.filter(
                  (item) => typeof item === 'string',
                );
                accumulator = [...accumulator, ...remainingProduct];
              } else {
                const isLabelRemain = response.filter(
                  (r) =>
                    r.group === 'Product' &&
                    !ProductLabel.includes(r.annotation_field),
                );
                if (isLabelRemain.length === 0) {
                  const filteredArray = accumulator.filter(
                    (item) =>
                      typeof item === 'string' && !item.startsWith('Product'),
                  );
                  accumulator = [...filteredArray];
                }
              }
            }
          });
          accumulator = accumulator.filter((item) => typeof item === 'string');
          return accumulator;
        },
        [],
      );
      const newBoxData = options.filter((item) => typeof item === 'string');
      setDataFields(newBoxData);
    }
  };
  const getLabel = () => {
    Object.values(checkedDataFields).forEach((response) => {
      response.forEach((DataField) => {
        if (
          DataField.annotation_field &&
          label === DataField.annotation_field
        ) {
          setLabel(DataField.short_desc);
        }
      });
    });
  };

  const groupOptions = (option) => {
    if (typeof option === 'string') {
      if (option.includes('Invoice')) {
        return 'Invoices';
      }
      if (option.includes('Payment')) {
        return 'Payments';
      }
      if (option.includes('Customer')) {
        return 'Customers';
      }
      if (option.includes('Supplier')) {
        return 'Suppliers';
      }
      if (option.includes('Product')) {
        return 'Products';
      }
      if (option.includes('Currency')) {
        return 'Invoices';
      }
      return 'Other';
    }
  };

  useEffect(() => {
    getLabel();
    if (openedData.label !== undefined) {
      setLabelExist(openedData.label);
    } else {
      setLabelExist('');
    }
    getAllDataFields();
  }, [label, labelExist]);

  const onLabelChange = (newLabel) => {
    setLabel(newLabel);
  };

  const checkedDataFieldsData = Object.values(checkedDataFields).flatMap(
    (group) => group,
  );

  const IsDataExistFromCheckFields = [
    ...checkedDataFieldsData
      .filter((item) => DataFields.includes(item.short_desc))
      .map((t) =>
        t.annotation_field !== null ? t.annotation_field : t.short_desc,
      ),
  ];

  const isAiData = data.filter((d) =>
    IsDataExistFromCheckFields.includes(d.label),
  );

  const IsDataExist = checkedDataFieldsData
    .filter((c) =>
      isAiData.map((a) => a.label).includes(c.annotation_field || c.short_desc),
    )
    .map((m) => m.short_desc);

  const confirmData = checkedDataFieldsData
    .filter((c) =>
      changedData
        .map((a) => a.label)
        .includes(c.annotation_field || c.short_desc),
    )
    .map((m) => m.short_desc);

  const renderAutoCompleteOption = (confirmedData, dataExist, option) => {
    if (confirmedData.includes(option)) {
      return (
        <AutoCompleteRenderOptionBox>
          <Typography>{option}</Typography>
          <StyledSVGIcon
            component={CheckedIcon}
            stroke="rgba(0, 191, 111, 1)"
          />
        </AutoCompleteRenderOptionBox>
      );
    }
    if (dataExist.includes(option)) {
      return (
        <AutoCompleteRenderOptionBox>
          <Typography>{option}</Typography>
          <StyledSVGCircleIcon component={CircleIcon} stroke="#FFA500" />
        </AutoCompleteRenderOptionBox>
      );
    }
    return <Typography>{option}</Typography>;
  };

  return (
    <Autocomplete
      disabled={versionId !== '' && isEditing === null}
      ListboxProps={{ className: 'Autocomplete_scrollbar' }}
      isOptionEqualToValue={(option, newValue) => option === newValue}
      size="small"
      value={label !== '' ? label : null}
      options={DataFields}
      groupBy={groupOptions}
      getOptionDisabled={(option) =>
        isDate ? !option.includes('Date') : option.includes('Date')
      }
      renderOption={(props, option) => (
        <li {...props}>
          {renderAutoCompleteOption(confirmData, IsDataExist, option)}
        </li>
      )}
      onChange={(event, newLabel) => {
        onLabelChange(newLabel);
        setIsDataFieldSelected(true);
      }}
      renderInput={(params) => <TextField {...params} />}
    />
  );
};

DataFieldDropdown.defaultProps = {
  label: null,
  versionId: '',
  isEditing: null,
};

const dataObjectPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  group: PropTypes.string.isRequired,
  short_desc: PropTypes.string.isRequired,
  annotation_field: PropTypes.string,
});

DataFieldDropdown.propTypes = {
  label: PropTypes.string,
  setLabel: PropTypes.func.isRequired,
  setIsDataFieldSelected: PropTypes.func.isRequired,
  checkedDataFields: PropTypes.shape({
    Invoice: PropTypes.arrayOf(dataObjectPropTypes),
    Supplier: PropTypes.arrayOf(dataObjectPropTypes),
    Payment: PropTypes.arrayOf(dataObjectPropTypes),
    Product: PropTypes.arrayOf(dataObjectPropTypes),
    Payment_Method: PropTypes.arrayOf(dataObjectPropTypes),
  }).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      label: PropTypes.string,
      value: PropTypes.string,
      product: PropTypes.number,
    }),
  ).isRequired,
  openedData: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    product: PropTypes.number,
  }).isRequired,
  products: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        product: PropTypes.number.isRequired,
      }),
    ),
  ).isRequired,
  changedData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      x: PropTypes.number.isRequired,
      y: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      label: PropTypes.string,
      value: PropTypes.string,
      product: PropTypes.number,
    }),
  ).isRequired,
  versionId: PropTypes.string,
  isEditing: PropTypes.bool,
  isDate: PropTypes.bool.isRequired,
};

export default DataFieldDropdown;
